/* eslint-disable react/jsx-sort-props */
import { graphql, type HeadFC, type PageProps } from 'gatsby';
import type { FC } from 'react';
import type { HomeLatestBlogs, HomePageData,BannerCaption } from '../@types/gql/home';
import HomeBlogsSection from '../components/home/blogs';
import HomeBrandsSection from '../components/home/brands';
import HomeCategoriesSection from '../components/home/categories';
import HomeDiscoverSection from '../components/home/discover';
import HomeFAQsSection from '../components/home/faqs';
import HomeHeroSection from '../components/home/hero';
import HomeIndustrySection from '../components/home/industry';
import SEOComponent from '../components/shared/seo';
import type { StrapiPopAvdData } from '../components/adsUI/pop-ads';
import { PopupAds } from '../components/adsUI/pop-ads';
import type { AllStrapiVideoSection } from '../components/videoModal';
import VideosWithModal from '../components/videoModal';

const Page: FC<
  PageProps<{allStrapiVideoSection: AllStrapiVideoSection;
    allStrapiPopAvd: StrapiPopAvdData; strapiHomePage: HomePageData; allStrapiBlog: HomeLatestBlogs; allStrapiHeroSection: BannerCaption 
}>
> = ({ data }) => {
  const {
    Banner,
    CategorySection,
    Discover,
    Clients,
    WorkpieceByIndustriesSection,
    FAQSection,
  } = data.strapiHomePage;


  return (
    <>
      <HomeHeroSection
        button={Banner.ActionButton}
        description={Banner.Description}
        products={Banner.products || []}
        title={Banner.Title}
        type={Banner.Background.ext}
        url={Banner.Background.url}
        bannerCaptions={data.allStrapiHeroSection.nodes || []}
      />
      <HomeCategoriesSection {...CategorySection} />
      <HomeDiscoverSection {...Discover} />
      {/* {Clients?.length ? <HomeBrandsSection clients={Clients} /> : null} */}
      <VideosWithModal nodes={data.allStrapiVideoSection.nodes||[]} />
      <HomeIndustrySection {...WorkpieceByIndustriesSection} />
      <HomeBlogsSection nodes={data.allStrapiBlog.nodes} />
      <HomeFAQsSection {...FAQSection} />
      <PopupAds nodes={data.allStrapiPopAvd.nodes}  />
    
    </>
  );
};
 
export default Page;

export const Head: HeadFC<{ strapiHomePage: HomePageData }> = ({ data }) => {
  return <SEOComponent seo={data.strapiHomePage.seo} />;
};

export const query = graphql`
  query HomePage {
    strapiHomePage {
      seo {
        ...SEOFragment
      }
      ...HomePageData
    }
    allStrapiBlog(limit: 4, sort: { publishedAt: DESC }) {
      nodes {
        Title
        Slug
        ShortDescription
        category
        Thumbnail {
          url
        }
        publishedAt
      }
    }
    allStrapiHeroSection {
      nodes {
        Title
        Description
        id
      }
    }
    allStrapiPopAvd {
      nodes {
        AdsImage {
          url
        }
        Button {
          Name
          URL 
          id
        }
        Descrption
        Heading
         isShowAds
      }
    }
  allStrapiVideoSection {
  nodes {
      SectionTitle
      AddVideos {
        MediaType
        Url
        id
        VideoTitle
        Thumbnail {
          url
        }
      }
    }
  }
  }
`